import { baseUrl } from "../../../../boot";
import axios from "axios";

// add collection  API
export const addwebOrder = async (formData) => {
    console.log("order form data ---- ", formData);
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}vancouverapis/webapp/orders/api/v1/create-order`, formData, {
            headers: {
                "auth-token": token,
            }
        },)
       
        return response;
    } catch (error) {
        throw error
    }
}